import {actionTypes, workplaceTypes} from "../types";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'

import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import {ModalContainerTGO} from "../Modal/ModalContainerTGO";
import {ModalContainerPAK} from "../Modal/ModalContainerPAK";
import {isCanvasBlank, savePAKtoDB} from "../functions";
import { VehicleNumberBlock } from "../Block/VehicleNumberBlock";
import SignaturePad from "signature_pad";
import {appNotification} from '@/components/AppNotification.js'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { cache } from '@/components/Cache.js';
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';
import { flightMenuBlock } from '@/Block/FlightMenuBlock.js';

var ServicesFilterForm = {
    controller: function (args) {
        this.model = args.model;
    },
    view: function (ctrl) {
        return m(".bg-info[style='padding:5px']", [
            m("form", [
                m(".col-xs-4", [
                    m("button.btn.btn-info[type='button']", {
                        onclick: function (e) {
                            e.preventDefault();
                            ctrl.model.sort();
                        }
                    }, [
                        m("span", "Услуга "),
                        ctrl.model.state ?
                            m("span.glyphicon", {
                                class: 'glyphicon-triangle-' + (ctrl.model.state === 'asc' ? 'top' : 'bottom')
                            }) : ''
                    ])
                ]),
                m(".col-xs-8", [
                    m(".input-group", [
                        m("input.form-control[type='text'][placeholder='Введите строку для поиска'][autocomplete='off']", {
                            id: 'search',
                            oninput: m.withAttr("value", ctrl.model.filter)
                        }),
                        m(".input-group-addon", {
                            onclick: function () {
                                document.querySelector('#search').value = '';
                                ctrl.model.reset();
                            }
                        }, [
                            m("i.fa.fa-times")
                        ])
                    ])
                ]),
                m(".container", [
                    m("button.btn.btn-warning[type='button'][style='width:100%;margin-top:4px']", {
                        onclick: function (e) {
                            e.preventDefault();
                            ctrl.model.show_all_services();
                        }
                    }, [
                        m("span", [
                                m("span", "Показать дополнительные услуги "),
                                FlightService.Required ? m("i.fa.fa-lg.fa-check") : ''
                            ]
                        )
                    ])
                ])
            ])
        ]);
    }
};

export const FlightService = {
    original: [],
    list: [],
    state: null,
    init: function () {
        return m.request({
            method: 'GET',
            url: '/api/task/' + m.route.param('taskId') + '/services'
        }).then(function (response) {
            server.setOnline();
            if (response.currentTask === null) {
                m.route('/');
            }

            FlightService.original = response.services.list;
            FlightService.list = response.services.list;
            appNotification.list = response.notifications;

            storage.config = response.config;
            storage.id_spp = response.currentTask.flightId;
            storage.id_skill = response.currentTask.skillId;

            server.initPing();
            appNotification.init();

            loader.hide();
            return response;
        }, function (response) {
            if (!response) {
                server.setOffline();
            }
            loader.hide();
        });
    },
    show_all_services: function () {
        FlightService.reset();
        if (FlightService.Required !== undefined) {
            FlightService.Required = !FlightService.Required;
        } else{
            FlightService.Required = true;
        }
    },
    sort: function () {
        var first = FlightService.list[0];
        FlightService.list.sort(function (a, b) {
            return a.title > b.title ? 1 : a.title < b.title ? -1 : 0
        });
        FlightService.state = 'asc';
        if (first === FlightService.list[0]) {
            FlightService.list.reverse();
            FlightService.state = 'desc';
        }
    },
    filter: function (prop) {
        FlightService.reset();
        FlightService.list = FlightService.list.filter(function (obj) {
            return obj.title.toLowerCase().indexOf(prop.toLowerCase()) !== -1;
        })
    },
    refresh: function () {
        FlightService.list.forEach(function (obj) {
            obj.showEditForm = false;
        })
    },
    reset: function () {
        FlightService.list = JSON.parse(JSON.stringify(FlightService.original));
    }
};

export var FlightServicesPage = {
    controller: function() {
        var self = this;

        if (!user.exists()) {
            m.route('/login');
            return;
        }

        interval.clearAll();

        loader.show();

        var data = FlightService.init();

        var topMenu;
        if (user.get('state.workplace') === workplaceTypes.driver) {
            topMenu = [
                { title: 'Задачи', url: '/vehicle/tasks', icon: 'fa-tasks' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];

            if (user.get('state.vehicleFreeTasksAvailable')) {
                topMenu.unshift(
                    { title: 'Свободные', url: '/vehicle/tasks/free', icon: 'fa-car' }
                )
            }
        } else {
            topMenu = [
                { title: 'Задачи', url: '/', icon: 'fa-tasks' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];
        }

        return {
            data: data,
            topMenu: topMenu,
            selectServiceData: function (e) {
                e.preventDefault();
                e.target.select();
            },
            saveServiceData: function (e) {
                e.preventDefault();
                self.errmsg = '';
                loader.show();

                const data = {
                    Id: parseInt(e.target.serviceId.value),
                    value: e.target.amount.value
                };

                if (parseFloat(data.value) < 0) {
                    self.errmsg = (m(".alert.alert-danger", 'Отрицательное значение услуги недопустимо'));
                    loader.hide();
                    return;
                }

                m.request({
                    method: 'PUT',
                    url: '/api/task/' + m.route.param('taskId') + '/services',
                    data: data
                }).then(function () {
                    server.setOnline();
                    loader.hide();
                    FlightService.list.find(x => parseInt(x.id) === data.Id).value = data.value;
                    FlightService.list.find(x => parseInt(x.id) === data.Id).showEditForm = false;
                    // Зачем обновляем путь? Убрал 28,02,2019
                    // m.route('/task/' + m.route.param('taskId') + '/services');
                    FlightService.init();
                }, function (response) {

                    data.type = actionTypes.flightServiceUpdate;
                    data.taskId = m.route.param('taskId');
                    cache.push(data);

                    if (response && response.message) {
                        self.errmsg = (m(".alert.alert-danger", response.message));
                    } else {
                        server.setOffline();
                    }
                    loader.hide();
                });
            }
        };
    },
    view: function(ctrl) {
        const disableManualChanges = ctrl.data().disableManualChanges || [];
        const disabledServices = disableManualChanges.services || [];

        return [
            m.component(HeaderMenuBlock, {
                time: ctrl.data().time,
                menu: ctrl.topMenu
            }),
            m("div[style='margin-top:0px']", [
                VehicleNumberBlock(),
                m.component(flightMenuBlock, {
                    board: ctrl.data().board,
                    menu: ctrl.data().menu,
                    tasks: ctrl.data().tasks,
                    currentTask: ctrl.data().currentTask,
                    tab: 'services'
                })
            ]),
            ctrl.errmsg,
            m.component(ServicesFilterForm, {
                model: FlightService
            }),
            ctrl.data().services.isActClosed ?
                m("div[style='padding:3px']",
                    m(".alert.alert-danger[style='margin:5px 0']",
                        m.trust("Акт по данному рейсу закрыт.<br />Внесение данных заблокировано")
                    )
                ) : "",
            m(".container", [
                FlightService.list.map(function (service) {                    
                    const restrictionServiceId = service.restrictionServiceId || service.id;
                    const disabled = disabledServices.map(String).includes(String(restrictionServiceId));
                    return [
                        ((!FlightService.Required && !service.NonRequired) || (FlightService.Required))
                            ?
                            m(".row",{
                                style: service.NonRequired ? 'background: #eee' : '',
                            }, [
                                m(".col-xs-7[style='padding:5px;']", [
                                    m(`button.btn.btn-block[data-service-id='${service.code}']`, {
                                        class: service.isClosed ? 'btn-default' : 'btn-success',
                                        style: ctrl.data().config.font_size_in_services
                                            ? 'overflow: hidden; line-height: 1.1; font-size: ' + ctrl.data().config.font_size_in_services + 'px'
                                            : 'overflow: hidden; line-height: 1.1; font-size: 1.5rem;',
                                        disabled: service.isClosed,
                                        onclick: function () {
                                            FlightService.refresh();
                                            service.showEditForm = !service.showEditForm;
                                        }
                                    },
                                        ctrl.data().config.short_name_in_services ? service.title_short : service.title)
                                ]),
                                m(".col-xs-5[style='padding:0 10px 0 5px']", [
                                    service.value > 0 ?
                                        m("div[style='padding:10px; text-align: center']", {
                                            class: service.showEditForm ? 'hidden' : ''
                                        }, service.value + " " + service.measureUnit + "") :
                                        "",
                                    m("form[autocomplete='off'][style='padding:3px']", {
                                        class: service.showEditForm ? '' : 'hidden',
                                        onsubmit: disabled ? null : ctrl.saveServiceData.bind(ctrl)
                                    }, [
                                        m("input[name='serviceId'][type='hidden'][value='" + service.id + "']"),
                                        m(".input-group[style='padding-bottom:3px']", [
                                            m("input.form-control[type='number'][step='any'][name='amount']", {
                                                disabled: disabled,
                                                min: 0,
                                                value: service.value === 0 ? ctrl.data().config.default_service_value : service.value,
                                                oncontextmenu: () => {return false},
                                                onfocus: ctrl.selectServiceData.bind(ctrl)
                                            }),
                                            m(".input-group-addon", service.measureUnit)
                                        ]),
                                        m(`button.btn.btn-info.btn-block.btn-lg[type='submit']`, {
                                            innerText:"Сохранить",
                                            disabled: disabled,
                                            })
                                    ])
                                ])
                            ]) : ''
                    ];
                })
            ]),
            m("div[style='padding:3px; text-align: center']",
                m("button.btn.btn-info.btn-lg[style='width:100%']", {
                    class: ctrl.data().config.AvailabilitySignature ? '' : 'hidden',
                    onclick: function () {
                        ModalContainerPAK.open(ctrl.data().currentTask);
                        var canvas = document.getElementById("canvasSignPAK");
                        if (canvas !== null) {
                            var signaturePad = new SignaturePad(canvas, {
                                backgroundColor: 'rgb(255, 255, 255)'
                            });
                        }
                        document.getElementById("save_sign_PAK").addEventListener("click", function () {
                            var canvas = document.getElementById("canvasSignPAK");
                            if(isCanvasBlank(canvas) == false)
                                savePAKtoDB();

                            ModalContainerPAK.close();
                        });

                        document.getElementById('clear_sign_PAK').addEventListener('click', function () {
                            let canvas = document.getElementById("canvasSignPAK");
                            if (canvas !== null) {
                                let signaturePad = new SignaturePad(canvas, {
                                        backgroundColor: 'rgb(255, 255, 255)'
                                    }
                                );
                                signaturePad.clear();
                            }
                        });
                    }

                }, [
                    "Подписать"
                ]),
                ModalContainerPAK.init(ctrl.data().currentTask)
            )
        ];
    }
};
